var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#262626"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 30,
    height: 30,
    rx: 15,
    stroke: "#F6F6F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.498 7.69036C19.7169 7.47149 19.9768 7.29787 20.2627 7.17942C20.5487 7.06097 20.8552 7 21.1647 7C21.4742 7 21.7807 7.06097 22.0667 7.17942C22.3527 7.29787 22.6125 7.47149 22.8314 7.69036C23.0503 7.90923 23.2239 8.16906 23.3423 8.45503C23.4608 8.741 23.5217 9.04749 23.5217 9.35702C23.5217 9.66655 23.4608 9.97305 23.3423 10.259C23.2239 10.545 23.0503 10.8048 22.8314 11.0237L11.5814 22.2737L6.99805 23.5237L8.24805 18.9404L19.498 7.69036Z",
    stroke: "#F6F6F6",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.d9ac1e8be7fcacd556ac0ab5ff651009.svg";
export { ForwardRef as ReactComponent };